import React from 'react'
import css from './style.scss'
import {connect} from 'react-redux';
import {FullPage, FullContainer} from 'components/container';
import {withRouter, Switch} from 'react-router-dom';
import AccountInfo from './account_info'
import AccountDownloadPage from 'components/account_page/download/index'
import AppRoute from 'utils/route'
import StoriesSection from './stories'
import StatsSection from './stats'
import AdventuresSection from './adventures'
import SettingsSection from './settings'
import TabBar from './tabs/index'
import PausedBar from './account_info/paused_bar'
import Loading from 'components/shared/loading'
import accountsApi from 'components/accounts_page/api'

class AccountPage extends React.Component{
  constructor(props){
    super(props)
    this.state={
      tabs:this.prepareTabs(props)
    }
  }
  componentDidMount(){
    if(!this.props.account){
      accountsApi.getAccount(this.props.match.params.id)
    }
  }
  prepareTabs=(props)=>{
    if(props.account){
      let base="/a/"+props.account.id
      let tabs=[
        {path:base, label:"Stories"},
        {path:base+"/stats", label:"Stats"},
        {path:base+"/adventures", label:"Adventures"}
      ]
      if(props.account.userRole==="creator"){
        tabs.push({path:base+"/settings", label:"Settings"})
      }
      return tabs
    }else{
      return []
    }

  }
  render(){
    return (
      <FullPage>
        <div className="shadow">
          <FullContainer>
            <AccountInfo {...this.props.account} />
            {this.props.account && this.props.account.paused_at && <PausedBar when={this.props.account.paused_at}/>}
            <TabBar tabs={this.state.tabs}/>
          </FullContainer>
        </div>
        <div className={css.storiesPage}>
            <FullContainer>
              {this.props.account &&
                <Switch>
                  <AppRoute isPrivate exact path="/a/:id/settings" component={SettingsSection}/>
                  <AppRoute isPrivate path="/a/:id/adventures" component={AdventuresSection}/>
                  <AppRoute isPrivate path="/a/:id/stats" component={StatsSection}/>
                  <AppRoute isPrivate path="/a/:id/download" component={AccountDownloadPage}/>
                  <AppRoute isPrivate path="/a/:id/" component={StoriesSection}/>
                </Switch>
              }
              {!this.props.account &&
                <Loading/>
              }
            </FullContainer>

        </div>
      </FullPage>
    )
  }
}

const mapStateToProps = function (state, props) {
  let account=state.accounts[props.match.params.id]
  return {
    account,
    user:state.user.userData,
  };
}

export default connect(mapStateToProps)(withRouter(AccountPage));



// WEBPACK FOOTER //
// ./src/components/account_page/index.js